module.exports = __webpack_public_path__ + "img/music-work-icon1.f279c40a.png";